<div class="modal-header">
    <h5 class="modal-title"><i class="fa-regular fa-plus" aria-hidden="true"></i> Opret felt</h5>
    <button type="button" class="btn-close" aria-label="Luk" [disabled]="saving()"
        (click)="activeModal.dismiss('Cross click')"></button>
</div>

<form class="modal-body" (submit)="$event.preventDefault(); create()">
    <p class="text-body-secondary">
        En resultatkolonne, som stored proceduren kan returnere, men som ikke blev fundet ved oprettelsen (fx fordi den
        afhænger af IF/CASE). Feltet oprettes som <strong>Hybrid</strong>, kan kun læses og tilføjes afdelingernes skabeloner.
    </p>
    <div class="row g-3">
        <div class="col-sm-6">
            <label class="form-label fw-semibold" for="field-column">Kolonne</label>
            <input type="text" class="form-control" id="field-column" autocomplete="off" maxlength="128"
                [class.is-invalid]="showError('column', columnError())" [disabled]="saving()"
                [value]="columnName()" (input)="columnName.set(text($event))" (blur)="touch('column')"
                aria-describedby="field-column-error">
            @if (showError('column', columnError()); as error) {
            <div class="invalid-feedback" id="field-column-error">{{ error }}</div>
            }
        </div>
        <div class="col-sm-6">
            <label class="form-label fw-semibold" for="field-name">Vist navn</label>
            <input type="text" class="form-control" id="field-name" autocomplete="off" maxlength="128"
                [placeholder]="columnName() || 'Som kolonne'"
                [class.is-invalid]="showError('name', nameError())" [disabled]="saving()"
                [value]="name()" (input)="name.set(text($event))" (blur)="touch('name')"
                aria-describedby="field-name-error">
            @if (showError('name', nameError()); as error) {
            <div class="invalid-feedback" id="field-name-error">{{ error }}</div>
            }
        </div>
        <div class="col-sm-6">
            <label class="form-label fw-semibold" for="field-type">Datatype</label>
            <select class="form-select" id="field-type" [disabled]="saving()" (change)="dataType.set(text($event))">
                @for (type of dataTypes; track type) {
                <option [value]="type" [selected]="type == dataType()">{{ type }}</option>
                }
            </select>
        </div>
        <div class="col-sm-6">
            <label class="form-label fw-semibold" for="field-length">Max. længde</label>
            @if (hasLength()) {
            <div class="input-group has-validation">
                <input type="number" class="form-control" id="field-length" min="1"
                    [class.is-invalid]="showError('length', lengthError())" [disabled]="saving() || isMax()"
                    [value]="isMax() ? '' : maxLength()" (input)="setMaxLength($event)" (blur)="touch('length')"
                    aria-describedby="field-length-error">
                <div class="input-group-text">
                    <input class="form-check-input mt-0 me-1" type="checkbox" id="field-max" [disabled]="saving()"
                        [checked]="isMax()" (change)="isMax.set(checked($event))">
                    <label class="form-check-label" for="field-max">MAX</label>
                </div>
                @if (showError('length', lengthError()); as error) {
                <div class="invalid-feedback" id="field-length-error">{{ error }}</div>
                }
            </div>
            } @else {
            <input type="text" class="form-control" id="field-length" disabled value="–">
            }
        </div>
        <div class="col-sm-6">
            <label class="form-label fw-semibold" for="field-default">DB Defaultværdi</label>
            <input type="text" class="form-control" id="field-default" autocomplete="off" [disabled]="saving()"
                [value]="dbDefaultValue()" (input)="dbDefaultValue.set(text($event))">
        </div>
        <div class="col-sm-6 d-flex align-items-end">
            <div class="form-check form-switch mb-2">
                <input class="form-check-input" type="checkbox" id="field-nullable" [disabled]="saving()"
                    [checked]="isNullable()" (change)="isNullable.set(checked($event))">
                <label class="form-check-label" for="field-nullable">Nullable</label>
            </div>
        </div>
    </div>
    <!-- Enter i et felt opretter; knappen sidder i footeren uden for formularen. -->
    <button type="submit" hidden aria-hidden="true" tabindex="-1"></button>
</form>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" [disabled]="saving()" (click)="activeModal.dismiss('Cancel')">Annuller</button>
    <button type="button" class="btn btn-success" [disabled]="saving()" (click)="create()">
        @if (saving()) {
        <span class="spinner-border spinner-border-sm me-2" role="status"><span class="visually-hidden">Opretter...</span></span>
        }
        Opret felt
    </button>
</div>
